export enum AlertType
{
    info = "alert--info",
    warning = "alert--warning",
    error = "alert--error"
}